var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "15.17mm",
    height: "15.77mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 43 44.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#Degradado_sin_nombre);isolation:isolate;opacity:.8;}.cls-3{fill:#d11664;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre",
    cx: 21.5,
    cy: 22.81,
    fx: 21.5,
    fy: 22.81,
    r: 21.5,
    gradientTransform: "translate(0 46) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#7474a4",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#d8d8e5",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 21.5,
    cy: 23.19,
    r: 21.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 16.26,
    cy: 14.63,
    r: 14.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.09,12.5c0-1.94-1.57-3.51-3.51-3.51h-8.98c-1.94,0-3.51,1.57-3.51,3.51v4.18c0,1.94,1.57,3.51,3.51,3.51h8.98c1.94,0,3.51-1.57,3.51-3.51,0,0,0-4.18,0-4.18Zm-5.28,2.4l-4.03,1.99c-.16.09-.69-.03-.69-.21v-4.09c0-.18.54-.3.7-.21l3.85,2.1c.16.09.33.33.17.41h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYoutube);
export default __webpack_public_path__ + "static/media/logoYoutube.736d43e7080a3da5e24228352a2ee350.svg";
export { ForwardRef as ReactComponent };